<!-- page header -->
<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>
      PIA Culinaare
    </ion-title>
    <img alt="PSI logo" slot="end" class="titleicon" [src]="assets + '/psi_logo.svg'" width="80px" routerLink="/home"/>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- Loading state -->
  <div *ngIf="loading" class="ion-padding ion-text-center">
    <ion-spinner></ion-spinner>
    <p>Loading menu data...</p>
  </div>

  <!-- Error state -->
  <ion-card *ngIf="error && !loading">
    <ion-card-content>
      <ion-text color="danger">
        <h2>{{error}}</h2>
      </ion-text>
    </ion-card-content>
  </ion-card>

  <!-- Menu content -->
  <div *ngIf="!loading && !error && menuData">
    <!-- Restaurant Information -->
    <ion-card color="primary" *ngIf="restaurantInfo">
      <ion-card-header>
        <ion-card-title>{{restaurantInfo.name}}</ion-card-title>
        <ion-card-subtitle *ngIf="restaurantInfo.nameEn">{{restaurantInfo.nameEn}}</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content *ngIf="information">
        <div *ngIf="information.title">
          <h2><strong>{{information.title}}</strong></h2>
          <p *ngIf="information.text" [innerHTML]="information.text"></p>
          <p *ngIf="information.textEn" [innerHTML]="information.textEn"></p>
        </div>
      </ion-card-content>
    </ion-card>

    <!-- Date selector -->
    <ion-list mode="md" lines="full">
      <ion-item>
        <ion-label>Date</ion-label>
        <ion-select interface="popover" [(ngModel)]="dateSelector" (ionChange)="switchDate()" placeholder="Select One">
          <ion-select-option value="today">{{today | date: 'dd.MM.yyyy'}}</ion-select-option>
          <ion-select-option value="tomorrow">{{tomorrow | date: 'dd.MM.yyyy'}}</ion-select-option>
          <ion-select-option value="dayaftertomorrow">{{dayaftertomorrow | date: 'dd.MM.yyyy'}}</ion-select-option>
        </ion-select>
      </ion-item>
    </ion-list>

    <!-- Debug Info -->
    <ion-card *ngIf="showDebugInfo && !loading && menuData" color="warning">
      <ion-card-header>
        <ion-card-title>Debug Info</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <p><strong>Restaurant Info:</strong> {{restaurantInfo ? 'Found' : 'Not Found'}}</p>
        <p><strong>Menu Types:</strong> {{getMenuTypes().join(', ') || 'None'}}</p>
        <p><strong>Selected Day:</strong> {{selectedDay}} ({{getDayName(selectedDay)}})</p>
        <p><strong>Single Day Types Available:</strong> {{getSingleDayTypeKeys().join(', ') || 'None'}}</p>
        <div *ngFor="let menuType of getMenuTypes()">
          <p><strong>{{menuType}}:</strong> {{getMenuItems(menuType, selectedDay).length}} items found</p>
        </div>
      </ion-card-content>
    </ion-card>

    <!-- Weekend message -->
    <ion-card *ngIf="isWeekend" color="light">
      <ion-card-content>
        <ion-text>
          <h2>No menus available on weekends.</h2>
        </ion-text>
      </ion-card-content>
    </ion-card>

    <!-- Menu items for each menu type -->
    <div *ngIf="!isWeekend">
      <div *ngFor="let menuType of getMenuTypes()">
        <ion-card *ngIf="getMenuItems(menuType, selectedDay).length > 0">
        <ion-card-header>
          <ion-card-title>{{getMenuTypeInfo(menuType)?.name}}</ion-card-title>
          <ion-card-subtitle *ngIf="getMenuTypeInfo(menuType)?.nameEn">{{getMenuTypeInfo(menuType)?.nameEn}}</ion-card-subtitle>
        </ion-card-header>
        <ion-card-content *ngFor="let menuItem of getMenuItems(menuType, selectedDay)">
          <ion-text *ngIf="menuItem.soup" class="ion-padding">
            <h2 class="ion-text-uppercase"><strong>Soup</strong></h2>
            <h2 [innerHTML]="menuItem.soup"></h2>
           
          </ion-text>
          <ion-text *ngIf="menuItem.main" class="ion-padding">
            <h2 *ngIf="menuItem.soup" class="ion-text-uppercase"><strong>Main</strong></h2>
            <h2 [innerHTML]="menuItem.main"></h2>

          </ion-text>
          <ion-text *ngIf="!menuItem.main && !menuItem.dessert" class="ion-padding">Currently not available</ion-text>
          <ion-text *ngIf="menuItem.dessert" class="ion-padding">
            <h2 *ngIf="menuItem.soup" class="ion-text-uppercase"><strong>Dessert</strong></h2>
            <h2 [innerHTML]="menuItem.dessert"></h2>

          </ion-text>
          <ion-text class="ion-text-right ion-padding">
            <h2 *ngIf="menuItem.price > 0">{{menuItem.price | number:'1.2-2'}} CHF</h2>
          </ion-text>
        </ion-card-content>
      </ion-card>
      </div>
    </div>



    <!-- Opening Hours (at bottom like Oase) -->
    <ion-card color="light" *ngIf="getParkInnovaareOpeningHours()">
      <ion-card-header>
        <ion-card-title>Opening Hours</ion-card-title>
        <ion-card-subtitle>Mon. - Fri.</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <ion-list mode="ios" lines="full">
          <ion-item color="light">
            <ion-label class="ion-textwrap">
              <ion-text>
                <h2>{{getParkInnovaareOpeningHours()?.title}}</h2>
              </ion-text>
              <ion-text color="medium">
                <h2>{{getParkInnovaareOpeningHours()?.text}}</h2>
              </ion-text>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-card-content>
    </ion-card>

    
  </div>
</ion-content>
